// extracted by mini-css-extract-plugin
export default {"description":"styles_description__Fi7H0","row":"styles_row__nKpvd","label":"styles_label__BANhM","value":"styles_value__bxpf8","highlighted":"styles_highlighted__ACKwl"};